const spellingTimes = [
    [
        "",
        100
    ],
    [
        "“",
        200
    ],
    [
        "You’re",
        745
    ],
    [
        "starting",
        460
    ],
    [
        "to",
        115
    ],
    [
        "see",
        172
    ],
    [
        "this",
        230
    ],
    [
        "today:",
        345
    ],
    [
        "as",
        115
    ],
    [
        "technology",
        775
    ],
    [
        "shrinks",
        402
    ],
    [
        "the",
        172
    ],
    [
        "world,",
        345
    ],
    [
        "it’s",
        730
    ],
    [
        "really",
        1045
    ],
    [
        "becoming",
        760
    ],
    [
        "one",
        672
    ],
    [
        "global",
        345
    ],
    [
        "marketplace",
        632
    ],
    [
        "for",
        172
    ],
    [
        "content.",
        460
    ],
    [
        "So",
        115
    ],
    [
        "I",
        57
    ],
    [
        "think",
        287
    ],
    [
        "you’ll",
        345
    ],
    [
        "have,",
        287
    ],
    [
        "by",
        115
    ],
    [
        "2030,",
        287
    ],
    [
        "content",
        402
    ],
    [
        "without",
        402
    ],
    [
        "borders,",
        460
    ],
    [
        "so",
        115
    ],
    [
        "to",
        115
    ],
    [
        "speak.",
        345
    ],
    [
        "You’ll",
        1045
    ],
    [
        "have",
        330
    ],
    [
        "content",
        402
    ],
    [
        "that",
        230
    ],
    [
        "will",
        230
    ],
    [
        "come",
        230
    ],
    [
        "from",
        230
    ],
    [
        "any",
        172
    ],
    [
        "part",
        230
    ],
    [
        "of",
        115
    ],
    [
        "the",
        172
    ],
    [
        "world",
        287
    ],
    [
        "that",
        230
    ],
    [
        "will",
        230
    ],
    [
        "be",
        115
    ],
    [
        "available",
        517
    ],
    [
        "to",
        115
    ],
    [
        "consumers",
        517
    ],
    [
        "all",
        172
    ],
    [
        "over",
        230
    ],
    [
        "the",
        172
    ],
    [
        "world.”",
        145
    ],
    [
        "",
        200
    ]
];

export default spellingTimes;